import React, { FC } from "react";
import { PostDataType } from "data/types";
import Link from "componentsTemplate/Link";
import Image from "componentsTemplate/Image";
import { PauseIcon, PlayIcon } from "@heroicons/react/24/solid";
import ButtonPlayMusicPlayer from "componentsTemplate/ButtonPlayMusicPlayer";

export interface ContactCardProps {
  className?: string;
  user: any;
}

const ContactCard: FC<ContactCardProps> = ({
  className = "h-full",
  user,
}) => {

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;


  const renderDefaultBtnListen = (state?: "playing") => {
    return (
      <div className="cursor-pointer inline-flex items-center mt-3 pr-4 py-0.5 hover:pl-0.5 cursor-pointer rounded-full transition-all hover:bg-primary-50 dark:hover:bg-neutral-900">
        <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 dark:bg-neutral-800 text-primary-6000 dark:text-primary-200">
          {state === "playing" ? (
            <PauseIcon className="w-5 h-5" />
          ) : (
            <PlayIcon className="w-5 h-5" />
          )}
        </span>

        <span className="ml-3 text-xs sm:text-sm font-medium">
          {state === "playing" ? "Now playing" : "Listen now"}
        </span>
      </div>
    );
  };

  return (
    <div
      key={user.id}
      className={`nc-Card15Podcast relative flex group items-center p-2 rounded-3xl border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 ${className}`}
    >
      <div className="w-1/4 flex-shrink-0">
        <Link
          href={`/${user.id}/perfil`}
          className="block h-0 aspect-w-1 aspect-h-1 relative rounded-full overflow-hidden shadow-lg"
        >            
          <Image
            className="object-cover w-full h-full grayscale"
            src={urlBase + "/storage/users/" + user.avatar_path}
            fill
            alt={user.name ?? ""}
            sizes="100px"
            isAvatar
          />
        </Link>
      </div>

      <div className="flex flex-col flex-grow ml-4">
        <h2 className={`nc-card-title block font-semibold text-sm sm:text-lg text-primary-700`}>
          <Link
            href={`/${user.id}/perfil`}
            className={`line-clamp-2`}
            title={user.name ?? ""}
          >
            {user.name ?? ""}
          </Link>
        </h2>
        <span className="text-xs text-neutral-500 dark:text-neutral-400 mt-1 ">
          {(user.address?.city ?? "") + " - " + (user.address?.state ?? "") + " - " + (user.address?.country ? (user.address?.country == "Brazil" ? "Brasil" : user.address?.country) : "")}
        </span>
        {/* <span className="text-xs text-neutral-500 dark:text-neutral-400 mt-1 ">
          {user.phone ?? "" + " - " }
        </span> */}
        {/* {IS_AUDIO && (
          <ButtonPlayMusicPlayer
            post={post}
            renderDefaultBtn={() => renderDefaultBtnListen()}
            renderPlayingBtn={() => renderDefaultBtnListen("playing")}
          />
        )} */}
      </div>
    </div>
  );
};

export default ContactCard;
